import JobsService from 'top20common/distribution/services/jobs';
import ProfilesService from 'top20common/distribution/services/profiles';

export default {
  getProfileAction(context) {
    context.commit('mutateProfileLoadingState', true);
    return context.dispatch('getProfileInBackgroundAction');
  },
  getProfileInBackgroundAction(context) {
    return new Promise((resolve, reject) => {
      ProfilesService.getProfile()
        .then(response => {
          context.dispatch('splitAndSaveCandidateProfileAction', response.data);
          context.commit('setQuestionnaireFormDataState', response.data);
          resolve(response.data);
        })
        .catch(errors => {
          context.commit('mutateProfileErrorState', errors);
          reject(errors);
        })
        .finally(() => {
          context.commit('mutateProfileLoadingState', false);
        });
    });
  },
  updateCandidateIsApplicantAction(context, {is_applicant}) {
    context.commit('mutateProfileUpdateLoadingState', true);
    return new Promise((resolve, reject) => {
      ProfilesService.updateProfile({is_applicant})
        .then(response => {
          context.commit('mutateProfileDetailsState', response.data);
          resolve(response);
        })
        .catch(errors => {
          context.commit('mutateProfileErrorState', errors);
          reject(errors);
        })
        .finally(() => {
          context.commit('mutateProfileUpdateLoadingState', false);
        });
    });
  },
  splitAndSaveCandidateProfileAction(context, data) {
    let {
      basic_information,
      experiences,
      education,
      projects,
      languages,
      skills,
      leave_reasons,
      trainings,
      ...profile
    } = data;

    basic_information.birth_date = basic_information.birth_date ? new Date(basic_information.birth_date) : null;
    context.commit('mutateProfileDetailsState', profile);
    context.commit('setBasicProfileDataState', basic_information);
    context.commit('setWorkExperiencesListState', experiences);
    context.commit('setEducationListState', education);
    context.commit('setProjectsListState', projects);
    context.commit('setLanguagesListState', languages);
    context.commit('setMotivatorsListState', leave_reasons);
    context.commit('setSkillsListState', skills);
    context.commit('setTrainingsListState', trainings);
  },
  fetchReferralCreationReferredJob(context, jobCode) {
    JobsService.getJob(jobCode)
      .then(response => {
        context.commit('setReferralCreationReferredJob', response.data.result);
      })
      .catch(() => {});
  }
};
